<template>
    <div>
        <h3 class="mt-3">Pickups</h3>

        <div class="">

            <div class="fs-small dark mt-2 mb-3">
                Select the type of pickup available for this event.
            </div>

            <div class="form-group pt-4">
                <div class="row">

                    <div class="col-sm-4">
                        <radio name="pickups" :value="false" v-model="pickups" @input="transportationOptionChanged">
                            No Transportation
                        </radio>
                    </div>

                    <div class="col-sm-4">
                        <radio name="pickups" :value="true" v-model="pickups" @input="transportationOptionChanged">
                            Pickup Lists
                        </radio>
                    </div>
                </div>

            </div>

            <div v-if="pickups">

                <div v-if="getIsLoadingRoutes" class="text-center">
                    <loader></loader>
                </div>

                <div v-else-if="routes.length > 0">
                    <div class="row border-bottom-light pb-2">
                        <div class="col-sm-10">
                        </div>
                        <div class="col-sm-2 text-center fs-smaller dark font-weight-600">
                            Locations
                        </div>
                    </div>

                    <div class="row align-items-center border-bottom-light py-2 darker" v-for="route in routes">
                        <div class="col-sm-1">
                            <checkbox v-model="route.checked" @input="routeCheckChanged"></checkbox>
                        </div>
                        <div class="col-sm-9">
                            <div>
                                <span class="lightest fs-small bg-dark radius-normal mr-1 px-2">{{(route.type == 1)? 'Pickup' : 'Dropoff'}}</span>
                                <span class="font-weight-600">{{route.name}}</span>
                            </div>
                            <div>
                                <span v-for="(itenerary, index) in route.iteneraries" class="fs-small dark">
                                    <span>{{itenerary.stop.name}}</span><span v-if="index+1 < route.iteneraries.length">, </span>
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-2 text-center font-weight-600 fs-small">
                            {{route.iteneraries.length}}
                        </div>
                    </div>

                    <!-- <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="createPickupList">
                        <i class="ico-add fs-smallest add-circle color-1"></i> Create new pickup list
                    </div> -->

                </div>

                <div v-else-if="routes.length == 0" class="fs-large darker font-weight-600 text-center mx-3">
                    <span>Looks like you have no lists created, please crete them <router-link class="darker" to="/inventory#transports">here</router-link>.</span>
                </div>

            </div>


        </div>


  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import extendedVSelect from '@/extends/vue-select'
    export default {
        data: function() {
            return {
                pickups: false,
                routes: [],
            }
        },
        props: {
            validations: {
                type: Object
            }
        },
        created: function() {
            this.routes = this.getAllRoutes

            // if editing a product
            if(this.getSelectedEvent.eventRoutes.length > 0){
                this.pickups = true;

                //mark product routes marked
                this.markProductRoutes();
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getSelectedEvent',
                'getAllRoutes',
                'getIsLoadingRoutes'
            ]),

        },
        methods:{
            ...mapActions([
                'openModal',
                'updateroductEditPriceData'
            ]),
            markProductRoutes: function() {
                this.routes.map(availableRoute => {
                    this.getSelectedEvent.eventRoutes.map(productRoute => {
                        if(productRoute.id == availableRoute.id){
                            this.$set(availableRoute, 'checked', true)
                            // availableRoute.checked = true
                        }
                    })
                })
            },
            routeCheckChanged: function() {
                this.getSelectedEvent.eventRoutes = this.routes.filter(route => {
                    return route.checked
                })
            },
            transportationOptionChanged: function (hasTransports) {
                if(!hasTransports){
                    this.getSelectedEvent.eventRoutes = []
                } else {
                    this.routeCheckChanged()
                }
            }
         },
        components: {
            vSelect: extendedVSelect,
            Loader
        }
    }
</script>

<style lang="scss" scoped>
    .app .v-select{display: inline-flex;}
</style>



// WEBPACK FOOTER //
// areaTransports.vue?36363be5